import { Typography } from '@sravni/react-design-system';

import type { Winner } from '@src/@types/ozonPrizeWinners';
import firstHistoryImageSrc from '@src/assets/octoberPrizeDraw/firstHistoryImage.png';
import secondHistoryImageSrc from '@src/assets/octoberPrizeDraw/secondHistoryImage.png';
import { MAIN_WINNER } from '@src/components/OctoberPrizeDraw/OctoberPrizeDrawPrizeWinner/components/MainWinner/constants';
import {
  WINNER_10000_LIST,
  WINNER_20000_LIST,
} from '@src/components/OctoberPrizeDraw/OctoberPrizeDrawPrizeWinner/components/OtherWinners/constants';
import { SECONDARY_WINNER_LIST } from '@src/components/OctoberPrizeDraw/OctoberPrizeDrawPrizeWinner/components/SecondaryWinners/constants';
import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';
import { sendOctoberPrizeDrawGoToVkVideoEvent } from '@src/helpers/analyticsEvents';

import styles from './OctoberPrizeDrawHistories/styles.module.scss';

const { Link } = Typography;

export const VkVideoLink = (
  <Link href="https://vk.com/video/@sravni" target="_blank" onClick={sendOctoberPrizeDrawGoToVkVideoEvent}>
    рандомайзера
  </Link>
);

export const getHistories = (isMobile: boolean) => {
  const separator = isMobile ? ' ' : UNBREAKABLE_SEPARATOR;

  return [
    {
      title: 'Новое авто с доставкой к подъезду',
      description: `Александр из Йошкар-Олы работает электриком в троллейбусном парке и${separator}водит${separator}свою${separator}«Ладу».${separator}Точнее, водил — в октябре 2023 года Сравни привёз новый, свежевыигранный автомобиль прямо к подъезду Александра.`,
      iconSrc: firstHistoryImageSrc,
      confettiImageClassName: styles.firstHistoryConfetti,
    },
    {
      title: 'Выиграть 500 тысяч и сократить срок ипотеки на 3 года',
      description:
        'Андрей живет в собственной квартире в Перми вместе с женой. Недавно они решили переехать в жилье побольше и взяли ипотеку на новое, а свою однушку начали сдавать. Иногда Андрей играет в лотерею, но выигрывал максимум 1 500 ₽.',
      iconSrc: secondHistoryImageSrc,
      confettiImageClassName: styles.secondHistoryConfetti,
    },
  ];
};

export const WINNER_LIST: Winner[] = [MAIN_WINNER].concat(SECONDARY_WINNER_LIST, WINNER_20000_LIST, WINNER_10000_LIST);
